/* Footer wordmark jello, the phone's way in. The animation's only trigger was
 * :hover (sections/d2-footer.liquid), which a touch screen never fires — so
 * the store's main traffic never saw it. On hover-less devices this plays it
 * once, when the mark scrolls into view. Desktop is deliberately untouched:
 * hover replays on every pass, and a scroll-past there stays still.
 */
(function () {
  'use strict';

  var mark = document.querySelector('.d2-footer__mark--jello');
  if (!mark) return;
  if (window.matchMedia('(hover: hover)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* 0.6: at 390px the mark is ~77px tall, so this is ~46px showing — past the
   * panel's top rounding, i.e. it fires when the mark is actually seen, not
   * when its first sliver clears the fold. Once is enough; disconnect. */
  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        mark.classList.add('is-inview');
        io.disconnect();
        return;
      }
    }
  }, { threshold: 0.6 });

  io.observe(mark);
})();
